import React, { FC } from 'react';
import cn from 'classnames';
import Check from '@crehana/crehana-icons/lib/CheckNew';
import transition from '../styles/transition';
import { AdornmentProps } from './types';
import parseClassnames from '../helpers/parseClassnames';

const Adornment: FC<AdornmentProps> = ({
  type,
  startAdornment,
  endAdornment,
  adornmentClassNames,
  chat,
  multirow,
}) => {
  let element = startAdornment;

  if (type === 'end') {
    element = endAdornment;
  } else if (type === 'check') {
    element = (
      <Check className="fill-current text-green-main" size={24} ignoreColor />
    );
  }

  return (
    <div
      className={parseClassnames(
        adornmentClassNames ? adornmentClassNames[type] || '' : '',
        cn(
          'flex items-center',
          type === 'start' ? 'pl-16' : 'pr-16',
          chat || multirow ? 'h-40' : 'h-56',
          { 'pb-16': multirow },
        ),
      )}
      style={{ transition: transition(['padding', 'height']) }}
    >
      {element}
    </div>
  );
};

export default Adornment;
